import React from 'react';
import { Input } from '../../atoms/Input/Input';
import { Label } from '../../atoms/Label/Label';
import { FormError } from '../../atoms/FormError/FormError';
import styles from './FormField.module.css';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

// Combinamos las props del Input con las nuestras (label, id, error)
interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  id: string;
  error?: boolean;
  // Hacemos que onChange y value sean más genéricos para soportar diferentes tipos de input
  onChange: (...args: any[]) => void;
  value?: any;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  id,
  error,
  type,
  value,
  onChange,
  ...inputProps }) => {

  const renderInput = () => {
    if (type === 'phone') {
      // PhoneInput espera un `value` y un `onChange` que maneja un string, no un evento.
      // Pasamos props para que el input interno se parezca a los demás.
      return <PhoneInput
        className={error ? styles.invalidPhone : undefined}
        inputClassName={styles.phoneInput}
        defaultCountry="co"
        value={value} onChange={onChange} />;
    }
    // El Input estándar recibe el resto de las props.
    return <Input id={id} name={id} isInvalid={error} type={type} value={value} onChange={onChange} {...inputProps} />;
  };

  if (type === 'checkbox') {
    return (
      <div className={styles.checkboxContainer + (error ? ` ${styles.invalidCheckboxContainer}` : '')}>
        <Input id={id} type="checkbox" isInvalid={error} value={value}onChange={onChange} {...inputProps} />
        <Label htmlFor={id}>{label}</Label>
        <FormError>{error}</FormError>
      </div>
    );
  }

  return (
    <div className="w-full mb-4 flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      {renderInput()}
      {/* <FormError>{error}</FormError> */}
    </div>
  );
};
